export enum MessageStatus {
    SUCCESS = 'SUCCESS',
    INFO = 'INFO',
    WARNING = 'WARNING',
    DANGER = 'DANGER'
};
